'use client';

import { Divider } from '@snack-uikit/divider';
import { List } from '@snack-uikit/list';
import { Scroll } from '@snack-uikit/scroll';
import { Typography } from '@snack-uikit/typography';
import cn from 'classnames';
import { usePathname } from 'next/navigation';

import { Condition, NavListItem } from '@/components/static';
import { usePageNavigationCtx } from '@/hooks/ctx';
import { checkIsActiveNavigationItem, getActiveElementParentIds, skipFileExtension } from '@/utils/navigation';

import s from './styles.module.scss';
import { createSidebarItems } from './utils';

type SidebarMenuProps = {
  className?: string;
  rootClassName?: string;
};

export function SidebarMenu({ className, rootClassName }: SidebarMenuProps) {
  const { sidebarTitleData, sidebarHtmlString, rootFolderSlug } = usePageNavigationCtx();
  const pathname = usePathname();

  if (!rootFolderSlug || !sidebarHtmlString) return null;
  const list = createSidebarItems(sidebarHtmlString, rootFolderSlug, NavListItem);
  const hasTitle = Boolean(sidebarTitleData?.text);

  const parentIds = getActiveElementParentIds({
    list,
    predicate: id => checkIsActiveNavigationItem('sidebar', { url: id, pathname }),
  });

  return (
    <div className={cn(rootClassName, s.sidebar_container)}>
      <Scroll size='s' barHideStrategy='never'>
        <div className={s.sidebar_content_wrapper}>
          <Condition when={hasTitle}>
            <div className={s.sidebar_title_container}>
              <Typography.SansTitleM> {sidebarTitleData?.text} </Typography.SansTitleM>
            </div>
          </Condition>
          <Condition when={hasTitle}>
            <Divider />
          </Condition>
          <List
            selection={{
              mode: 'single',
              value: skipFileExtension('all', pathname),
            }}
            collapse={{ defaultValue: parentIds }}
            items={list}
            size='m'
            className={className}
          />
        </div>
      </Scroll>
    </div>
  );
}
